import PaymentState from 'Types/_Store/Payment'
import { ActionTree, MutationTree, GetterTree, Store } from 'vuex'
import { getCardList, addCard, deleteCard, updateMainCard } from 'Api/creditCardApi'
import { parseCard } from 'Parsers/creditCardParser'
import { formatCard } from 'Formatters/creditCardFormatter'
import { StoreState, CreditCard, CreditCardAdd, ApiCreditCardAddResult } from 'Types'
import paymentTypes from 'Enums/paymentTypes'

const state: PaymentState = {
  requesting: {
    cardList: false,
    cardAdd: false,
    cardDelete: false,
    cardUpdateMain: false,
  },

  selectedPayment: null,
  selectedCard: null,
  selectedBoleto: false,
  selectedPix: false,

  creditCardList: []
}

const getters: GetterTree<PaymentState, StoreState> = {
  isPaymentSelected: (state) => {
    return state.selectedPayment !== null
  },

  selectedPaymentInfo: (state) => {
    const paymentList = paymentTypes.toList('id')

    return paymentList.find(payment => payment.id === state.selectedPayment) || null
  },

  selectedCardInfo: (state) => {
    return state.creditCardList.find(card => card.id === state.selectedCard) || null
  }
}

const mutations: MutationTree<PaymentState> = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_credit_card_list(state, creditCardList) {
    state.creditCardList = creditCardList
  },

  set_selected_payment(state, selectedPayment) {
    state.selectedPayment = selectedPayment
  },

  set_selected_card(state, selectedCard) {
    state.selectedCard = selectedCard
  },

  set_selected_boleto(state, selectedBoleto) {
    state.selectedBoleto = selectedBoleto
  },

  set_selected_pix(state, selectedPix) {
    state.selectedPix = selectedPix
  }
}

const actions: ActionTree<PaymentState, StoreState> = {
  async getCreditCardList({ commit }): Promise<CreditCard[]> {
    commit('request_start', 'cardList')

    try {
      const { data } = await getCardList()
      const cardList = data.map(parseCard)

      commit('set_credit_card_list', cardList)
      commit('request_success', 'cardList')

      return cardList
    } catch (err) {
      commit('request_failure', 'cardList')

      throw err
    }
  },

  async addCreditCard({ commit }, card: CreditCardAdd): Promise<ApiCreditCardAddResult> {
    commit('request_start', 'cardAdd')

    try {
      const newCard = formatCard(card)
      const { data } = await addCard(newCard)

      commit('request_success', 'cardAdd')

      return data
    } catch (err) {
      commit('request_failure', 'cardAdd')

      throw err
    }
  },

  async deleteCreditCard({ commit }, cardId: number): Promise<number> {
    commit('request_start', 'cardDelete')

    try {
      await deleteCard(cardId)

      commit('request_success', 'cardDelete')

      return cardId
    } catch (err) {
      commit('request_failure', 'cardDelete')

      throw err
    }
  },

  async updateMainCard({ commit }, cardId: number): Promise<null> {
    commit('request_start', 'cardUpdateMain')

    try {
      await updateMainCard(cardId)

      commit('request_success', 'cardUpdateMain')

      return null
    } catch (err) {
      commit('request_failure', 'cardUpdateMain')

      throw err
    }
  },

  selectPayment({ commit }, paymentId) {
    commit('set_selected_payment', paymentId)
  },

  selectCard({ commit }, cardId) {
    commit('set_selected_card', cardId)
    commit('set_selected_boleto', false)
    commit('set_selected_pix', false)
  },

  selectBoleto({ commit }) {
    commit('set_selected_card', null)
    commit('set_selected_boleto', true)
    commit('set_selected_pix', false)

  },

  selectPix({ commit }) {
    commit('set_selected_card', null)
    commit('set_selected_boleto', false)
    commit('set_selected_pix', true)

  },
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}